import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import StyleTwoSectionTitle from './StyleTwoSectionTitle'
import StyleTwoCombinClassItem from './StyleTwoCombinClassItem'

export class StyleTwoCombinClass extends Component {
  static propTypes = {
    styleTwo: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    defaultIndex: 1,
    itemsData: {}
  }
  componentWillMount() {
    this.setState({ itemsData: this.props.itemsData });
  }

  toggleTabs(id) {
    let { itemsData } = this.state;
    itemsData.listData.map(item => {
      if(item.id === id){
        item.active = true;
      }else{
        item.active = false
      }
    })
    this.setState({ itemsData, defaultIndex: id })
  }

  render() {
    const { itemsData, defaultIndex } = this.state;
    const { ContentColor, onMeiQiaCustomer } = this.props;
    return (
      <div className="style-two-style-two-combin-class">
        <a name={itemsData.name}><StyleTwoSectionTitle isColorW={false} Data={itemsData} /></a>
        <div className='self_study_combin' style={{ background: `url(${itemsData.totalbackImg}) no-repeat` }}>
          <div className='combin_container'>
            <div className='combin_tabs'>
              {itemsData.listData && itemsData.listData.map(item => <div className={item.active ? 'combin_tabs_item active' : 'combin_tabs_item'} style={{ backgroundColor: `${item.active ? ContentColor : '#fff'}` }} key={item.id} onClick={this.toggleTabs.bind(this, item.id)}>{item.title}</div>)}
            </div>
            <div className='combin_content_list flex_row'>
              {itemsData.listData[defaultIndex - 1].list.map(item => <StyleTwoCombinClassItem itemsData={item} key={item.id} onMeiQiaCustomer={onMeiQiaCustomer} />)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    styleTwo: state.styleTwo,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoCombinClass);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoCombinClass.js